import React, { useEffect, useState } from "react";
import { DriverBasicDetailsContainer } from "../../../constants/assets/DriverDetailsContainers";
import { useHistory, useParams } from "react-router-dom";
import { connect } from "react-redux";
import Order from "./Order";
import ODetails from "./Details";
import Items from "./Items";
import Lifecycle from "./Lifecycle";
import Trip from "./Trip";
import Address from "./Address";
import { getPath } from "../../../utils";
import HorizontalTabs from "sushiweb/HorizontalTabs";
import { getCookie, getDashboardUrl } from "../../../views/Home";
import { HOSTS } from "../../../constants/Host/hosts";
import { SourceId, Category } from "./Common/constants";

const TabBasic = {
  name: "Basic",
  url: "",
};
const TabItems = {
  name: "Items",
  url: "items",
};
const TabTrip = {
  name: "Trip",
  url: "trip",
};
const TabAddress = {
  name: "Address",
  url: "address",
};
const TabOrderLifecycle = {
  name: "OrderLifecycle",
  url: "lifecycle",
};
const TabOrderRun = {
  name: "OrderRun",
  url: "orderrun",
};
const TabOrderPayouts = {
  name: "OrderPayouts",
  url: "orderpayouts",
}; 

const Details = ({ details, menus }) => {
  console.log("Details: menus", menus);
  const subTabs = [TabBasic, TabItems, TabOrderLifecycle, TabAddress, TabTrip, TabOrderRun, ...(menus.has("ORDER_PAYOUT") ? [TabOrderPayouts] : [])];
  const history = useHistory();
  const { id, detailType } = useParams();
  const [curSubTab, setCurSubTab] = useState("");
  const [initialState, setInitialState] = useState({});

  const openOrderRun = (order_id) => {
    if (!order_id) {
      return;
    }
    const url = `${getDashboardUrl()}/tracking/track?id=${order_id}`;
    window.open(url);
  };

  const openOrderPayouts = (order_id, order, order_payouts) => {
    if (!order_id) {
      return;
    }
    var baseUrl = ""
    const loginHost = getCookie("login_host");
    if (loginHost == HOSTS.HOST_INTERNAL) {
        baseUrl = process.env.REACT_APP_NEW_DASHBOARD_URL_INTERNAL;
    } else {
        baseUrl = process.env.REACT_APP_NEW_DASHBOARD_URL_EXTERNAL;
    }

    var order_payout_url = order_payouts?.url;
    const url = `${baseUrl}${order_payout_url}`;
    window.open(url);
  };


  const getCurrentTabComponent = () => {
    switch (curSubTab) {
      case TabOrderLifecycle.url:
        return <Lifecycle data={getPath(details, "order_lifecycle", {})} />;
      case TabAddress.url:
        return <Address data={details.order_address} />;
      case TabItems.url:
        return <Items data={getPath(details, "order_items", {})} />;
      case TabTrip.url:
        return (
          <Trip
            data={{
              trip: getPath(details, "trip", {}),
              lifecycle: getPath(details, "trip_lifecycle", {}),
            }}
          />
        );
      case TabOrderRun.url: 
        return openOrderRun(id); 
      case TabOrderPayouts.url:
        return openOrderPayouts(id, details?.order, details?.order_payouts);   
      default:
        return (
          <div>
            <Order data={getPath(details, "order", {})} />
            <ODetails data={getPath(details, "order_details", {})} />
          </div>
        );
    }
  };

  useEffect(() => {
    setCurSubTab(detailType);
  }, [detailType]);

  return (
    <DriverBasicDetailsContainer>
      <HorizontalTabs id="sushi-tabs" className="mb-20" alignLinks="left">
        {subTabs.map((tab, index) => {
          return (
            <HorizontalTabs.Link
              active={curSubTab == tab.url}
              onClick={() => {
                history.push(`/orders/${id}/${tab.url}`);
              }}
              key={index}
              className={`tab${index}${curSubTab === tab.url}`}
            >
              {tab.name}
            </HorizontalTabs.Link>
          );
        })}
      </HorizontalTabs>
      {getCurrentTabComponent()}
    </DriverBasicDetailsContainer>
  );
};

function mapStateToProps(state) {
  const { Orders } = state;
  return {
    details: Orders.Order,
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Details);
